import { createReducer, on } from '@ngrx/store';
import {
  deleteUserStories,
  getUserStories,
  saveUserStories,
  saveUserStoriesOrder,
  setUserStories,
  setUserStoriesOrder,
  updateUserStories,
  deleteFileAttachments,
  selectFileAttachments
} from '../actions/userstories.actions';

export interface UserStoriesState {
  data: any;
}

export const initialState: UserStoriesState = {
  data: {}
};

export const userstoriesReducer = createReducer(
  initialState,
  on(getUserStories, (state, { apiConstants }) => ({
    ...state,
    ...apiConstants
  })),
  on(saveUserStories, (state, { userstoriesData }) => ({
    ...state,
    ...userstoriesData
  })),
  on(saveUserStoriesOrder, (state, { userstoriesOrderData }) => ({
    ...state,
    ...userstoriesOrderData
  })),
  on(setUserStories, (state, { userStoriesTable }) => ({
    ...state,
    ...{ userStoriesTable }
  })),
  on(setUserStoriesOrder, (state, { userStoriesOrder }) => ({
    ...state,
    ...{ userStoriesOrder }
  })),
  on(updateUserStories, (state, { userstoriesData }) => {
    return {
      ...state,
      ...{ userstoriesData }
    };
  }),
  on(deleteUserStories, (state, { ids }) => {
    return {
      ...state,
      ids
    };
  }),
  on(deleteFileAttachments, (state) => {
    return {
      ...state
    };
  }),
  on(selectFileAttachments, (state, { response }) => ({
    ...state,
    ...{ response }
  }))
);
